export const API_GET_VOUCHER_PENDING = "/comprobantes/pendientes/";
export const API_GET_SEARCH_PENDING =`/comprobantes/pendientes/busqueda/`